<script setup lang="ts">
import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: getOperationOffice | null;
  initialOperationOfficeId?: number;
  errorMessages?: string[];
  disabled?: boolean;
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: getOperationOffice | null): void
}>()

const operationOffice = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <FormRow
    :title="i18n.global.t('pages.gpsTrackerSetting.operationOffice')"
    :required="true"
  >
    <SingleOperationOfficeAutoComplete
      v-model="operationOffice"
      :initial-operation-id="props.initialOperationOfficeId"
      :error-messages="errorMessages"
      :clearable="false"
      :disabled="disabled"
      class="autocomplete-width"
    />
  </FormRow>
</template>

<style scoped>
.autocomplete-width {
  max-width: 300px;
}
</style>
